import { PatternFormat } from 'react-number-format'
import styled from 'styled-components'

interface IProps {
  onChange: (phoneNumber: string) => void
  value: string
  name: string
  label?: string | JSX.Element
  required?: boolean
}

export const InputUsPhone = ({ onChange, value, name, label, required = false }: IProps) => {
  return (
    <Div className="d-block my-3 mb-4">
      <label htmlFor={name}>
        {label && <div className="labelText">{label}</div>}
        <PatternFormat
          name="phoneNumber"
          format="+1 (###) ### ####"
          allowEmptyFormatting
          mask="_"
          onValueChange={(value: any) => onChange(value.formattedValue)}
          required={required}
          value={value}
        />
      </label>
    </Div>
  )
}

const Div = styled.div`
  width: 100%;

  label {
    position: relative;
    width: 100%;

    & > * {
      color: ${({ theme }) => theme.colors.grey.dark};
    }

    input {
      ${({ theme }) => theme.typography.s.normal};

      color: ${({ theme }) => theme.colors.grey.dark};
      padding: 0.5rem 0.75rem;
      border: none;
      outline: 1px solid ${({ theme }) => theme.colors.grey.dark};
      border-radius: ${({ theme }) => theme.borderRadius.normal};
      width: 100%;

      &:focus {
        outline-color: ${({ theme }) => theme.colors.primary.light};
      }

      &::placeholder {
        color: ${({ theme }) => theme.colors.grey.dark}80;
      }

      &.invalid {
        outline-color: ${({ theme }) => theme.colors.error.dark};
      }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }

    span {
      cursor: pointer;
      position: absolute;
      right: 1rem;
      margin-top: 0.5rem;
    }
  }

  .labelText {
    text-align: left;
    ${({ theme }) => theme.typography.xxs.normal};
    padding-bottom: 0.25rem;
  }
`
